import React, { useEffect, useState } from "react";
import ReactSelect from "@common/ReactSelect";
import DatePicker from "react-multi-date-picker";
import * as HELPER from "@src/config/helper";
import { TRAVEL_LIST_DATE_FILTERS } from "./travelListData";

const TravelListTopFilter = (props: any) => {
    const [selectedFilters, setSelectedFilters] = useState<any>(props.selectedFilters || {});
    const [showDateRangeCdr, setShowDateRangeCdr] = useState(false);
    const [errField, setErrField] = useState<any>({
        date_range: "",
    });

    useEffect(() => {
        setSelectedFilters(props.selectedFilters || {});
        setShowDateRangeCdr(props.selectedFilters?.datetype === "cdr");
    }, [props.selectedFilters]);

    const handleChangeDateRange = (selectedOption: any) => {
        const updatedFilters: any = { ...selectedFilters };

        if (selectedOption.length === 2) {
            updatedFilters.from_date = selectedOption[0] ? selectedOption[0].format("YYYY-MM-DD") : null;
            updatedFilters.to_date = selectedOption[1] ? selectedOption[1].format("YYYY-MM-DD") : null;
        } else {
            updatedFilters.from_date = selectedOption[0]?.format("YYYY-MM-DD");
            updatedFilters.to_date = null;
        }

        setSelectedFilters(updatedFilters);
        props.onFilterChange(updatedFilters);
    };

    const handleChange = (selectedOption: any, key: string) => {
        let updatedFilters = { ...selectedFilters };

        if (key === "datetype") {
            const value = selectedOption.value;
            updatedFilters.datetype = value;

            if (value !== "cdr") {
                const dateRange: any = HELPER.dateReturn(value);
                updatedFilters.from_date = dateRange?.from_date || "";
                updatedFilters.to_date = dateRange?.to_date || "";
                setShowDateRangeCdr(false);
            } else {
                updatedFilters.from_date = "";
                updatedFilters.to_date = "";
                setShowDateRangeCdr(true);
            }
        }

        setSelectedFilters(updatedFilters);
        props.onFilterChange(updatedFilters);
    };

    const onFilterSearch = () => {
        if (selectedFilters.datetype === "cdr" && (!selectedFilters.from_date || !selectedFilters.to_date)) {
            setErrField({
                ...errField,
                date_range: "From date and To date are required.",
            });
            return;
        }

        setErrField({ ...errField, date_range: "" });
        props.submitHandler({ ...selectedFilters, page_number: 1 });
    };

    const onFilterReset = () => {
        const resetFilters = props.getDefaultFilters();
        setSelectedFilters(resetFilters);
        setShowDateRangeCdr(resetFilters.datetype === "cdr");
        props.resetHandler(resetFilters);
    };

    return (
        <React.Fragment>
            <h3>Filters</h3>
            <div className="lead-list-filter travel-list-filter">
                <div className="filter-filed-form">
                    <ReactSelect
                        options={TRAVEL_LIST_DATE_FILTERS}
                        value={TRAVEL_LIST_DATE_FILTERS.find((v: any) => selectedFilters.datetype === v.value) || null}
                        handleChange={(e: any) => handleChange(e, "datetype")}
                        placeholder="Select Duration"
                        fieldSetClassName=""
                        fieldKey="datetype"
                    />

                    {showDateRangeCdr && (
                        <fieldset className="multi-datepicker datepicker">
                            <div className={(selectedFilters?.from_date) ? "material animation-effect active-label" : "material animation-effect"}>
                                <DatePicker
                                    value={[selectedFilters?.from_date, selectedFilters?.to_date]}
                                    onChange={(e: any) => handleChangeDateRange(e)}
                                    placeholder=""
                                    range
                                />
                                <label title="" data-label="Date Range*" className="form-label datepick-heading"></label>
                                {errField.date_range && <span className="error-txt date-range-error">{errField.date_range}</span>}
                            </div>
                        </fieldset>
                    )}

                    <div className="btn-submit-reset">
                        <button className="btn-primary" onClick={onFilterSearch}>Search</button>
                        <button className="btn-reset travel-refresh-btn" onClick={onFilterReset} title="Reset">
                            <i className="ic-refresh"></i>
                        </button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default TravelListTopFilter;
